import styled, { css } from "styled-components";

import { staffLines } from "../../../common/styles";

import Spring from "../../components/Spring";
import { IWrapperStyleProps } from "./interfaces";

export const StyledPlan = styled(Spring)`
    min-height: calc(100vh - 50px);
    background-color: ${p => p.theme.c.snow};
    padding-top: 20px !important;
`;

export const Wrapper = styled.div<IWrapperStyleProps>`
    position: relative;
    padding-bottom: 2px;
    ${p =>
        p.moderatorView &&
        css`
            padding-bottom: 36px;
            ${p.theme.sm.max(css`
                padding-bottom: 118px;
            `)}
        `}
`;

export const ContentWrapper = styled.div`
    position: relative;

    ${p =>
        p.theme.xs(css`
            display: block;
        `)}
`;

export const StyledLoader = styled.div`
    margin-top: 100px;
    ${p =>
        p.theme.sm.min(css`
            margin-top: calc((100vh - 150px) / 2);
        `)}
`;

export const Listed = styled.div`
    margin-bottom: 20px;
`;

export const Promo = styled.div`
    background-color: ${p => p.theme.c.dark};

    background-size: 100% 109.3%;

    ${staffLines}
    text-align: center;
    margin: 0 -20px -2px;
    overflow: hidden;
    padding-bottom: 10px;
    p {
        color: ${p => p.theme.c.light};
        font-size: 18px;
        margin: 20px 0;
        padding: 0 30px;
        line-height: 1.4;
    }

    a {
        display: inline-block;
        width: 200px;
        margin: 0 12px 12px;
    }

    ${p =>
        p.theme.xs(css`
            a {
                display: block;
                margin: 0 auto 12px;
            }
        `)}

    .pulsate {
        display: inline-block;
    }
`;

export const TopAdSense = styled.div`
    display: block;
    margin-bottom: 20px;
    margin-top: 10px;
    ${p =>
        p.theme.xs(css`
            display: none;
        `)}
`;
